export class SIQFAQListItemTheme {
  backgroundColor = "null";
  titleTextColor = "null";
  subtitleTextColor = "null";
  subtitlePartitionColor = "null";
  likePendingColor = "null";
  likedColor = "null";
  separatorColor = "null";
}
//# sourceMappingURL=SIQFAQListItemTheme.js.map